import { useTranslation } from 'react-i18next';

import styles from './MarketingPanel.module.scss';
import PartnerLogo2 from './assets/WHITEWEDDING-theblog-featured-button.png';
import LogoDark from './assets/fotofunken-logo-inline-dark.svg';
import LogoLight from './assets/fotofunken-logo-inline-light.svg';
import PartnerLogo1 from './assets/pretty_words_freie_trauungen_logo_12_1000x400.png';
import { demoAlbumUrl, marketingContent, type Highlight } from './marketing-content';

const MarketingPanel = (): JSX.Element => {
  const { i18n } = useTranslation();
  const content = i18n.language.startsWith('en') ? marketingContent.en : marketingContent.de;

  return (
    <aside
      aria-label="Über Fotofunken"
      className={styles.panel}
      data-testid="split-signup-marketing-panel"
    >
      <img src={LogoLight} alt="Fotofunken" className={styles.logo} />
      <img src={LogoDark} alt="Fotofunken" className={styles.logoDark} />
      <ol className={styles.highlights}>
        {content.highlights.map((highlight: Highlight, index: number) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={index} className={styles.highlightItem}>
            <div className={styles.highlightHeader}>
              <span className={styles.badge} aria-hidden="true">
                {index + 1}
              </span>
              <h2 className={styles.headline}>{highlight.headline}</h2>
            </div>
            <p className={styles.description}>{highlight.description}</p>
          </li>
        ))}
      </ol>
      <div className={styles.cooperation}>
        <p className={styles.cooperationLabel}>{content.cooperationLabel}</p>
        <div className={styles.partnerLogos}>
          <img
            src={PartnerLogo1}
            alt="Pretty Words Freie Trauungen"
            className={styles.partnerLogoPrettyWords}
          />
          <img src={PartnerLogo2} alt="White Wedding" className={styles.partnerLogoWhiteWedding} />
        </div>
      </div>
      <hr className={styles.separator} />
      <p className={styles.footerNote}>
        <span className={styles.stars} aria-hidden="true">
          ★★★★★
        </span>
        <span>
          {content.learnMoreQuestion}{' '}
          <a href={demoAlbumUrl} target="_blank" rel="noopener noreferrer">
            {content.demoLinkText}
          </a>
        </span>
      </p>
    </aside>
  );
};

export default MarketingPanel;
